import MasterTable from './MasterTable'

/* ข้อมูลหลัก → ฝ่าย (function งาน) · backend: src/routes/adminFunctions.js

   ⚠️ คีย์คือ FunctionCode และ **แก้ไม่ได้** หลังสร้างแล้ว — Users.FunctionCode อ้างอยู่
      โดยไม่มี FK คอยตาม (เหมือนสาขา) · ตารางนี้สร้างโดย sql/mssql/027_branch_to_province_function.sql
   function เดิมเคยอยู่ในตาราง Branch (ก่อน 027 แยก "สาขา = จังหวัด" ออกจาก "ฝ่าย = function") */

type Func = {
  FunctionCode: string
  FunctionName: string
  CompanyCode: string
  inactive: boolean
  staffCount: number
}

export default function Functions() {
  return (
    <MasterTable<Func>
      title="ฝ่าย (function)"
      unit="ฝ่าย"
      companyScoped
      addLabel="เพิ่มฝ่าย"
      base="/api/admin/functions"
      keyOf={(r) => r.FunctionCode}
      labelOf={(r) => `${r.FunctionCode} ${r.FunctionName}`}
      isInactive={(r) => r.inactive}
      cols={[
        { label: 'รหัส', cell: (r) => r.FunctionCode, sortKey: 'code' },
        { label: 'ชื่อฝ่าย', cell: (r) => r.FunctionName, sortKey: 'name' },
        { label: 'พนักงาน', cell: (r) => r.staffCount, num: true, sortKey: 'staff' },
      ]}
      fields={[
        /* ย้ายฝ่ายข้ามบริษัทไม่ได้หลังสร้าง — Users ผูกด้วย (FunctionCode, CompanyCode) คู่กัน */
        { name: 'companyCode', label: 'บริษัท', required: true, lockOnEdit: true, source: 'companies' },
        { name: 'functionCode', label: 'รหัสฝ่าย', maxLength: 10, required: true, lockOnEdit: true },
        { name: 'functionName', label: 'ชื่อฝ่าย', maxLength: 50, required: true },
      ]}
      toDraft={(r) => ({
        companyCode: r.CompanyCode,
        functionCode: r.FunctionCode,
        functionName: r.FunctionName,
      })}
    />
  )
}
